module.exports = __webpack_public_path__ + "img/diamonds-with.87846fc.webp";